import axios from 'axios'

const dashAxios = axios.create({
  baseURL: 'https://cerberus-backend-production.up.railway.app/cerberus/api/v1',
  // baseURL: 'http://localhost:3002/cerberus/api/v1',
})

// export const getDashboardQuery = async (url, role, query, token) => {
//   const response = await dashAxios.get(`${url}/${role}/${query}`, {
//     headers: {
//       Authorization: `Bearer ${token}`
//     }
//   })
//   return response.data
// }

export const getActiveClientsQuery = async (url) => {
  const response = await dashAxios.get(`${url}`)
  return response.data
}

export const getAllClientsQuery = async (url) => {
  const response = await dashAxios.get(`${url}`)
  return response.data
}

export const checkAccessTokenQuery = async (url, token) => {
  const response = await dashAxios.get(`${url}`)
  return response.data
}

export const getEventsResumeQuery = async (url) => {
  const response = await dashAxios.get(url)
  return response.data
}

export const getAllInvolveds = async (url) => {
  const response = await dashAxios.get(url)
  return response.data
}

export const getClientBySlug = async (url, slug, id) => {
  const response = await dashAxios.get(`${url}/${slug}/${id}`)
  return response.data
}

export const createNewEventQuery = async (
  url,
  formData,
  data,
  jwt,
  accessToken,
  userId
) => {
  const response = await dashAxios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${jwt}`,
      AccessToken: `${accessToken}/${userId}`,
    },
    params: data,
  })
  console.log(response)
  return response
}

export const getProjectsByClientIdQuery = async (url, clientId, jwt) => {
  const response = await dashAxios.get(`${url}/${clientId}`, {
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  })
  return response
}

export const getProjectsByIdQuery = async (url, id, jwt) => {
  const response = await dashAxios.get(`${url}/${id}`, {
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  })
  return response
}

export const getDashboardQuery = async (url, role, query) => {
  const response = await dashAxios.get(`${url}/${role}/${query}`)
  return response.data
}

export const createUserAccount = async (url, user, token) => {
  const newUser = await dashAxios.post(url, user, token, {
    headers: {
      Authorization: `Bearer ${token} `,
    },
  })
  return newUser
}

export const createNewClientQuery = async (url, client) => {
  const response = await dashAxios.post(url, client)
  return response
}

export const createNewProjectQuery = async (url, project) => {
  console.log(project)
  const response = await dashAxios.post(url, project)
  return response
}

export const queryLogin = async (url, user) => {
  const response = await dashAxios.post(url, user)
  return response
}

export const getAllUsersQuery = async (url) => {
  const response = await dashAxios.get(url)
  return response.data
}
export const editProfileQuery = async (url, user) => {
  const response = await dashAxios.put(url, user)
  return response.data
}

export const createOrEditDashboardQuery = async (url, dashboard, token) => {
  const response = await dashAxios.post(url, dashboard, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

/**
 * Realiza una solicitud PATCH para eliminar una cuenta.
 * @param {string} url - La URL de la ruta de eliminación de la cuenta.
 * @param {string} clientId - El clientId de la cuenta que se va a eliminar.
 * @param {string} jwt - El token JWT utilizado para la autorización.
 * @param {string} accessToken - El token de acceso utilizado para la autorización.
 * @returns {Promise} - Una promesa que se resuelve en los datos de la respuesta de la solicitud.
 * @throws {Error} - Se lanza un error si la solicitud no es exitosa.
 */
export const deleteAccountOrProjectQuery = async (url, data, jwt) => {
  const response = await dashAxios.patch(`${url}/${data.clientId}`, data, {
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  })
  console.log(response)
  return response
}

export const updateClientsDataQuery = async (url, client, jwt, accessToken) => {
  const response = await dashAxios.patch(`${url}/${client.id}`, client, {
    headers: {
      Authorization: `Bearer ${jwt}`,
      // AccessToken: `${accessToken}`,
    },
  })

  return response
}

export const getProjectsQuery = async (url, jwt, accessToken) => {
  const response = await dashAxios.get(url, {
    headers: {
      Authorization: `Bearer ${jwt}`,
      AccessToken: `${accessToken}`,
    },
  })
  return response.data
}

export default dashAxios
